import { render, staticRenderFns } from "./df-recipe-card.vue?vue&type=template&id=a1f5f752&"
import script from "./df-recipe-card.ts?vue&type=script&lang=js&"
export * from "./df-recipe-card.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports